// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2Ww09","modalForm":"UpgradeEpcsModal_modalForm__3vNXG","modalFooter":"UpgradeEpcsModal_modalFooter__rdYeC"};